import React, { useEffect, useState, useRef } from 'react';
import ReactDrawer from 'react-drawer';
import './AskDeliveryHelpQuestion.scss';
// import { Link, BrowserRouter } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { Modal, Badge } from 'react-bootstrap';
import { displaySuccessToast } from 'helpers/toaster';
import OrdersViewDetail from 'views/orders/OrdersViewDetail';
// import qA from './Group_175769.svg';
import { getQuestionAnswer, insertOrderShipQustionAnswer } from '../../action/action';

function ViewQuestionDetail({ shipment, questionId, question = {}, openPopup, refetch = () => {} }) {
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const showPop = queryParams.get('showPopup');
  const [position, setPosition] = useState();
  const [showOrderModal, setShowOrderModal] = useState();
  const [qAnsData, setqAnsData] = useState([]);
  const [open, setOpen] = useState(openPopup);
  const [isLoading, setIsLoading] = useState(false);
  const [replyQuestionIndex, setReplyQuestionIndex] = useState(null);
  const [replyQuestion, setReplyQuestion] = useState(null);
  const [newMessage, setNewMessage] = useState(false);
  const [unreadMessage, setUnreadMessage] = useState(true);
  const messageBoxRef = useRef(null);

  const [askQues, setAskQues] = useState('');
  const getAnsQuesFunc = async () => {
    const data = {
      reference_no: shipment,
    };

    const result = await getQuestionAnswer(data);

    if (result) {
      setqAnsData(result);
      // setReplyQuestionIndex(result?.[0]?.qa_id);
      const unread = result.find((message) => message.is_replied === '0' && message.created_by === 'customer');
      setUnreadMessage(unread);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      if (openPopup === 'true') {
        setOpen(true);
        getAnsQuesFunc();
      }
    }, 100);
  }, [openPopup]);

  useEffect(() => {
    if (questionId) {
      setReplyQuestionIndex(questionId);
    }
  }, [questionId]);
  // Clone the original array and sort it

  const toggleRightDrawer = () => {
    setPosition('right');
    setOpen(!open);
  };
  const onDrawerClose = () => {
    setOpen(false);
  };
  const askQuestionFunc = async (reference) => {
    setIsLoading(true);
    const params = {
      qa_description: askQues,
      reference_no: reference,
      created_by: 'seller',
    };
    if (replyQuestionIndex) {
      params.parent_id = replyQuestionIndex;
      params.is_replied = 1;
      params.qa_type = '2';
    } else {
      params.is_replied = 0;
      params.qa_type = '1';
    }
    const isSuccess = await insertOrderShipQustionAnswer({
      params,
    });

    if (isSuccess) {
      setAskQues('');
      setReplyQuestionIndex(0);
      setReplyQuestion(null);
      getAnsQuesFunc();
      displaySuccessToast('Your message has been sent successfully!');
      refetch();
    }
    setIsLoading(false);
  };

  return (
    <>
      <Modal className="modal-right x2-large" show={!!showOrderModal} onHide={() => setShowOrderModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">#{showOrderModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrdersViewDetail id={showOrderModal} />
        </Modal.Body>
      </Modal>
      <If condition={question?.created_by === 'customer' && question?.is_replied === '0'}>
        <div
          className="viewQueries mt-3"
          onClick={() => {
            toggleRightDrawer();
            getAnsQuesFunc();
          }}
        >
          <span>Reply</span>
        </div>
      </If>
      <If condition={!(question?.created_by === 'customer' && question?.is_replied === '0')}>
        <div
          className="viewQueries mt-3"
          onClick={() => {
            toggleRightDrawer();
            getAnsQuesFunc();
          }}
        >
          <span>View</span>
        </div>
      </If>

      <ReactDrawer open={open} position={position} onClose={onDrawerClose}>
        <div className="askHelpPopup">
          <div className="askHelpContain">
            <Row className="mb-3">
              <Col>
                <div className="askHelpTitle">
                  <h3>Customer Messages</h3>
                </div>
              </Col>
              {/* <Col className="textAlignRight">
                <BrowserRouter forceRefresh>
                  <Link
                    to={`/orders/${orderId}/?order_mode=${split}&orderCn=${orderCn}`}
                    className="btn btn-sm btn-outline-warning waves-effect waves-light mr-2"
                  >
                    <i className="mdi mdi-eye-outline" />{' '}
                  </Link>
                </BrowserRouter>
              </Col> */}
            </Row>

            <div className="askHelpMessageContain">
              <div className="askHelpRefId">
                Looking Help for Order Ref :{' '}
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    setShowOrderModal(shipment);
                  }}
                >
                  {shipment}
                </span>
              </div>
              {qAnsData?.map((qa) => {
                let badge;
                let user = 'Unknown';
                if (qa?.created_by === 'customer') {
                  badge = <Badge>C</Badge>;
                  user = 'Customer';
                } else if (qa?.created_by === 'seller') {
                  badge = <Badge bg="secondary">S</Badge>;
                  user = 'Supplier Support';
                } else if (qa?.created_by === 'admin') {
                  badge = <Badge bg="danger">D</Badge>;
                  user = 'Danube Support';
                }
                return (
                  <>
                    <div className="askHelpMessage">
                      <div className="customerMessage">
                        {/* <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                          <g id="Group_175552" data-name="Group 175552" transform="translate(-1463 -92)">
                            <circle id="Ellipse_211" data-name="Ellipse 211" cx="21" cy="21" r="21" transform="translate(1463 92)" fill="#2b2b2b" />
                            <g id="Group_175551" data-name="Group 175551" transform="translate(1471.708 100.951)">
                              <path
                                id="Path_85075"
                                data-name="Path 85075"
                                d="M12.286,24.605H.68c-.526,0-.687-.161-.68-.693a20.167,20.167,0,0,1,.242-3.27,5.63,5.63,0,0,1,3.1-4.16,21.61,21.61,0,0,1,3.827-1.494c.69-.212,1.386-.408,2.083-.6.161-.043.186-.115.2-.269a.919.919,0,0,0-.487-.991,4.873,4.873,0,0,1-1.707-2.182,9.539,9.539,0,0,1-.5-7.016A5.207,5.207,0,0,1,10.3.309a6.589,6.589,0,0,1,4.112.04,5.294,5.294,0,0,1,3.455,3.728,9.582,9.582,0,0,1-.144,5.871,7.472,7.472,0,0,1-1.085,2.158,4.451,4.451,0,0,1-1.395,1.284.184.184,0,0,0-.113.187c.008.239-.072.52.028.7s.421.167.646.232a36.1,36.1,0,0,1,4.482,1.5,11.38,11.38,0,0,1,1.478.774,5.507,5.507,0,0,1,2.594,3.941,20.762,20.762,0,0,1,.226,3.331.5.5,0,0,1-.534.538c-.192.005-.385,0-.577,0H12.286m.007-.984q5.545,0,11.09,0c.167,0,.233-.027.219-.214-.038-.509-.041-1.021-.084-1.53a7.359,7.359,0,0,0-.488-2.225,4.631,4.631,0,0,0-2.139-2.248,17.546,17.546,0,0,0-3.328-1.352c-.972-.311-1.955-.586-2.942-.848-.314-.083-.456-.227-.459-.492-.006-.531,0-1.062,0-1.593a.436.436,0,0,1,.28-.423,3.36,3.36,0,0,0,1.628-1.495,8.625,8.625,0,0,0,.907-6.7,4.5,4.5,0,0,0-2.035-2.839A5.186,5.186,0,0,0,12.015,1,4.447,4.447,0,0,0,7.748,4.071,7.865,7.865,0,0,0,7.369,7.7a8.4,8.4,0,0,0,1.011,3.284A3.719,3.719,0,0,0,10.145,12.7a.461.461,0,0,1,.282.464c0,.471,0,.942,0,1.414,0,.41-.1.535-.5.644-1.171.317-2.339.642-3.489,1.032a14.244,14.244,0,0,0-3.135,1.4,4.431,4.431,0,0,0-2.01,2.8,15.178,15.178,0,0,0-.311,2.943c-.008.2.055.234.24.234q5.535-.008,11.07,0"
                                transform="translate(0 0)"
                                fill="#fff"
                              />
                            </g>
                          </g>
                        </svg>
                      </div> */}
                        <div className="messageIcon">
                          {/* <If condition={qa?.created_by === 'customer'}>
                            <Badge>C</Badge>
                          </If>
                          <If condition={qa?.created_by === 'seller'}>
                            <Badge bg="secondary">S</Badge>
                          </If>
                          <If condition={qa?.created_by === 'admin'}>
                            <Badge bg="danger">D</Badge>
                          </If> */}
                          {badge}
                        </div>
                        <div className="contentData">
                          <div className={`message ${qa?.is_replied === '1' ? 'read' : ''} `}>
                            <p className="user">{user}</p>
                            <p className="time">
                              <b> {qa?.created_at}</b>
                              <svg xmlns="http://www.w3.org/2000/svg" width="14.435" height="8.162" viewBox="0 0 14.435 8.162">
                                <g id="Group_175571" data-name="Group 175571" transform="translate(-49.999 -2.418)">
                                  <path
                                    id="Path_85078"
                                    data-name="Path 85078"
                                    d="M77.953,4.3a.721.721,0,0,1,.474-.618.665.665,0,0,1,.638.158c.856.865,1.72,1.721,2.577,2.585.1.1.152.115.26.007Q85.039,3.289,88.182.149a.654.654,0,0,1,1.032.288.57.57,0,0,1-.145.609q-.829.843-1.657,1.687l-1.561,1.59-1.6,1.633c-.524.534-1.052,1.064-1.569,1.6a1.865,1.865,0,0,1-.616.522.6.6,0,0,1-.772-.161c-.41-.429-.837-.841-1.254-1.263Q79.222,5.833,78.412,5a2.435,2.435,0,0,1-.3-.334,2.186,2.186,0,0,1-.161-.365"
                                    transform="translate(-24.813 2.418)"
                                  />
                                  <path
                                    id="Path_85079"
                                    data-name="Path 85079"
                                    d="M167.264,1.552a.574.574,0,0,1,.633.411.6.6,0,0,1-.166.677q-1.695,1.686-3.381,3.38a.63.63,0,0,1-1.081-.271.6.6,0,0,1,.163-.623q1.7-1.7,3.4-3.4a.471.471,0,0,1,.428-.174"
                                    transform="translate(-106.664 0.936)"
                                  />
                                  <path
                                    id="Path_85080"
                                    data-name="Path 85080"
                                    d="M3.79,96.716a.529.529,0,0,1-.407-.178Q1.792,94.95.206,93.358a.591.591,0,0,1-.021-.88A.61.61,0,0,1,1.02,92.4a1.344,1.344,0,0,1,.182.151q1.521,1.518,3.04,3.039a.644.644,0,0,1-.277,1.1,1.173,1.173,0,0,1-.174.027"
                                    transform="translate(50 -86.137)"
                                  />
                                </g>
                              </svg>
                            </p>
                            <p>{qa?.description}</p>
                          </div>

                          <If condition={qa?.answers.length === 0 && qa?.created_by !== 'seller' && replyQuestionIndex !== qa?.qa_id}>
                            <div className="replay">
                              {' '}
                              <span
                                className="rplyButton"
                                onClick={() => {
                                  setReplyQuestionIndex(qa?.qa_id);
                                  setReplyQuestion(qa);
                                  setTimeout(() => {
                                    if (messageBoxRef.current) {
                                      messageBoxRef.current.focus();
                                      messageBoxRef.current.scrollIntoView({ behavior: 'smooth' });
                                    }
                                  }, 500);
                                }}
                              >
                                Reply
                              </span>{' '}
                            </div>
                          </If>
                        </div>
                      </div>
                      {qa?.answers?.map((ans, key) => {
                        let answerBadge;
                        let answerUser = 'Unknown';
                        if (ans?.created_by === 'customer') {
                          answerBadge = <Badge>C</Badge>;
                          answerUser = 'Customer';
                        } else if (ans?.created_by === 'seller') {
                          answerBadge = <Badge bg="secondary">S</Badge>;
                          answerUser = 'Supplier Support';
                        } else if (ans?.created_by === 'admin') {
                          answerBadge = <Badge bg="danger">D</Badge>;
                          answerUser = 'Danube Support';
                        }
                        return (
                          <div className="replayMessage" key={key}>
                            <div className="contentData">
                              <div className={`message ${qa?.is_replied === '1' ? 'read' : ''} `}>
                                <p className="user">{answerUser}</p>
                                <p className="time">
                                  <b>{ans?.created_at}</b>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14.435" height="8.162" viewBox="0 0 14.435 8.162">
                                    <g id="Group_175571" data-name="Group 175571" transform="translate(-49.999 -2.418)">
                                      <path
                                        id="Path_85078"
                                        data-name="Path 85078"
                                        d="M77.953,4.3a.721.721,0,0,1,.474-.618.665.665,0,0,1,.638.158c.856.865,1.72,1.721,2.577,2.585.1.1.152.115.26.007Q85.039,3.289,88.182.149a.654.654,0,0,1,1.032.288.57.57,0,0,1-.145.609q-.829.843-1.657,1.687l-1.561,1.59-1.6,1.633c-.524.534-1.052,1.064-1.569,1.6a1.865,1.865,0,0,1-.616.522.6.6,0,0,1-.772-.161c-.41-.429-.837-.841-1.254-1.263Q79.222,5.833,78.412,5a2.435,2.435,0,0,1-.3-.334,2.186,2.186,0,0,1-.161-.365"
                                        transform="translate(-24.813 2.418)"
                                      />
                                      <path
                                        id="Path_85079"
                                        data-name="Path 85079"
                                        d="M167.264,1.552a.574.574,0,0,1,.633.411.6.6,0,0,1-.166.677q-1.695,1.686-3.381,3.38a.63.63,0,0,1-1.081-.271.6.6,0,0,1,.163-.623q1.7-1.7,3.4-3.4a.471.471,0,0,1,.428-.174"
                                        transform="translate(-106.664 0.936)"
                                      />
                                      <path
                                        id="Path_85080"
                                        data-name="Path 85080"
                                        d="M3.79,96.716a.529.529,0,0,1-.407-.178Q1.792,94.95.206,93.358a.591.591,0,0,1-.021-.88A.61.61,0,0,1,1.02,92.4a1.344,1.344,0,0,1,.182.151q1.521,1.518,3.04,3.039a.644.644,0,0,1-.277,1.1,1.173,1.173,0,0,1-.174.027"
                                        transform="translate(50 -86.137)"
                                      />
                                    </g>
                                  </svg>
                                </p>
                                <p>{ans?.description}</p>
                              </div>
                            </div>
                            {/* <div className="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                            <g id="Group_175554" data-name="Group 175554" transform="translate(-1463 -92)">
                              <circle id="Ellipse_211" data-name="Ellipse 211" cx="21" cy="21" r="21" transform="translate(1463 92)" fill="#289be8" />
                              <g id="Group_175557" data-name="Group 175557" transform="translate(1473.329 102.328)">
                                <path
                                  id="Path_85076"
                                  data-name="Path 85076"
                                  d="M32.319,14.332H30.61c-.32,0-.439-.1-.444-.422-.007-.461,0-.923,0-1.384a.326.326,0,0,1,.335-.335.343.343,0,0,1,.347.327c.01.216,0,.432,0,.649,0,.324.132.458.457.459.934,0,1.868.006,2.8,0a1.079,1.079,0,0,0,1.06-.969.4.4,0,0,0-.416-.474c-.472.019-.945.006-1.418,0-.358,0-.51-.185-.405-.528a9.692,9.692,0,0,0,.449-3.077c-.007-.308-.023-.614-.06-.92-.042-.347.077-.486.433-.491.336,0,.672.006,1.008,0a.371.371,0,0,0,.414-.413,8.646,8.646,0,0,0-.336-2.529,4.557,4.557,0,0,0-3.5-3.268,9.467,9.467,0,0,0-4.7.046A4.567,4.567,0,0,0,23.23,4.493a9.181,9.181,0,0,0-.262,2.267.367.367,0,0,0,.4.408c.171,0,.342,0,.512,0a.326.326,0,0,0,.346-.268c.068-.258.125-.52.209-.773a4.47,4.47,0,0,1,2.1-2.668,5.088,5.088,0,0,1,2.43-.589,5.25,5.25,0,0,1,2.787.663,4.349,4.349,0,0,1,1.123.962.4.4,0,0,1,.106.423.325.325,0,0,1-.526.148,3.906,3.906,0,0,1-.293-.31A3.734,3.734,0,0,0,29.75,3.61a5.458,5.458,0,0,0-2.033.13,3.551,3.551,0,0,0-2.473,2.188,7.294,7.294,0,0,0-.48,2.978,8.78,8.78,0,0,0,1.469,4.88,5.207,5.207,0,0,0,1.631,1.605,2.1,2.1,0,0,0,1.792.292.339.339,0,0,1,.392.086.348.348,0,0,1-.183.586,2.575,2.575,0,0,1-1.723-.052,4.9,4.9,0,0,1-2.054-1.565,8.458,8.458,0,0,1-1.32-2.261c-.118-.294-.123-.293-.443-.293h-1.64a1.787,1.787,0,0,1-1.849-1.8,9.923,9.923,0,0,1,.035-1.74,1.564,1.564,0,0,1,.946-1.254.666.666,0,0,0,.463-.734,7.963,7.963,0,0,1,.558-3.172A5.194,5.194,0,0,1,26.46.33,10.348,10.348,0,0,1,30.405.08a7.094,7.094,0,0,1,2.4.676,5.212,5.212,0,0,1,2.755,3.472,8.924,8.924,0,0,1,.308,2.6.453.453,0,0,0,.324.487A1.712,1.712,0,0,1,37.308,8.93c.019.523.022,1.049,0,1.572a1.688,1.688,0,0,1-1,1.481c-.05.026-.1.048-.156.07a.425.425,0,0,0-.278.441,1.758,1.758,0,0,1-1.257,1.755,2.1,2.1,0,0,1-.641.081c-.552,0-1.1,0-1.657,0v0M23.27,11.471c.216,0,.433,0,.649,0a.365.365,0,0,0,.386-.5,9.975,9.975,0,0,1-.232-2.662.365.365,0,0,0-.4-.434c-.364,0-.729-.007-1.093,0a1.048,1.048,0,0,0-1.025.922,9.688,9.688,0,0,0,0,1.756,1.027,1.027,0,0,0,.831.885,3.775,3.775,0,0,0,.885.029M36.608,9.7c-.021-.3.03-.6-.012-.9a1.082,1.082,0,0,0-1.017-.915c-.358-.006-.717,0-1.076,0-.3,0-.444.147-.43.444a9.806,9.806,0,0,1-.236,2.643.368.368,0,0,0,.394.506c.421.005.842,0,1.264,0A1.074,1.074,0,0,0,36.607,10.4c.009-.233,0-.466,0-.7"
                                  transform="translate(-17.97 0.001)"
                                  fill="#fff"
                                />
                                <path
                                  id="Path_85077"
                                  data-name="Path 85077"
                                  d="M11.107,126.329q-5.083,0-10.166,0a3.87,3.87,0,0,1-.614-.005.339.339,0,0,1-.322-.4,5.768,5.768,0,0,1,1.116-2.8,2.175,2.175,0,0,1,1.831-.855,7.126,7.126,0,0,0,1.583-.082,3.012,3.012,0,0,0,1.78-1.095c.09-.11.177-.223.268-.332a.336.336,0,0,1,.469-.081.341.341,0,0,1,.092.483,4.068,4.068,0,0,1-1.432,1.34,4.149,4.149,0,0,1-1.887.465c-.307.011-.615.017-.922.006a1.394,1.394,0,0,0-1.122.483,4.057,4.057,0,0,0-.888,1.747.357.357,0,0,0,.359.437c.17.01.342.005.513.005H20.834c.405,0,.562-.209.44-.591a4.831,4.831,0,0,0-.593-1.28,1.744,1.744,0,0,0-.906-.744,1.3,1.3,0,0,0-.386-.056,12.071,12.071,0,0,1-1.535-.055,3.633,3.633,0,0,1-2.309-1.269c-.112-.129-.222-.26-.322-.4-.17-.236-.156-.418.028-.555s.37-.1.546.142a4.175,4.175,0,0,0,.793.843,2.953,2.953,0,0,0,1.77.58c.4.015.8-.008,1.2.018a2.242,2.242,0,0,1,1.75,1.139A6.255,6.255,0,0,1,22.2,125.9a.335.335,0,0,1-.331.424c-.466.018-.933.01-1.4.01H11.107Z"
                                  transform="translate(0 -104.118)"
                                  fill="#fff"
                                />
                              </g>
                            </g>
                          </svg>
                        </div> */}

                            <div className="messageIcon">
                              {answerBadge}
                              {/* <If condition={ans?.created_by === 'customer'}>
                              <Badge>C</Badge>
                            </If>
                            <If condition={ans?.created_by === 'seller'}>
                              <Badge bg="secondary">S</Badge>
                            </If>
                            <If condition={ans?.created_by === 'admin'}>
                              <Badge bg="danger">D</Badge>
                            </If> */}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <hr className="breaker" />
                  </>
                );
              })}
            </div>
            <If condition={newMessage || replyQuestionIndex}>
              <div className="askHelpTextArea">
                <If condition={replyQuestion}>
                  <div className="replyTag">
                    <div className="title-wrap">Replying to</div>
                    <div className="contentData">
                      <div className="message">
                        <p className="user">{replyQuestion?.created_by === 'admin' ? 'Danube Support' : 'Customer'}</p>
                        <p className="time">
                          <b> {replyQuestion?.created_at}</b>
                        </p>
                        <p>{replyQuestion?.description}</p>
                      </div>
                    </div>
                    {/* <div className="sendBtn">
                      <span
                        className="btn btn-outline-info mt-3 textAlignRight sendBtn"
                        onClick={() => {
                          setReplyQuestion(null);
                          setReplyQuestionIndex(null);
                        }}
                      >
                        Cancel
                      </span>
                    </div> */}
                  </div>
                </If>
                <textarea
                  value={askQues}
                  onChange={(e) => {
                    setAskQues(e.target.value);
                  }}
                  placeholder="Please Enter Your Message"
                  className="form-control"
                  rows={5}
                  cols={5}
                  ref={messageBoxRef}
                />
                <div className="sendBtn">
                  <span
                    className="btn btn-outline-info mt-3 textAlignRight sendBtn"
                    onClick={() => {
                      setReplyQuestion(null);
                      setReplyQuestionIndex(null);
                      setNewMessage(null);
                    }}
                  >
                    Cancel
                  </span>
                  <If condition={!isLoading}>
                    <span
                      className="btn btn-primary mt-3 textAlignRight sendBtn"
                      onClick={() => {
                        askQuestionFunc(shipment);
                      }}
                    >
                      Submit
                    </span>
                  </If>
                  <If condition={isLoading}>
                    <span className="btn btn-primary mt-3 textAlignRight sendBtn disabled">Submit</span>
                  </If>
                </div>
              </div>
            </If>
            <If condition={!newMessage && !replyQuestionIndex && !unreadMessage}>
              <span
                className="btn btn-primary m-3 textAlignRight sendBtn"
                onClick={() => {
                  setNewMessage(true);
                }}
              >
                New Message
              </span>
            </If>
          </div>
        </div>
      </ReactDrawer>
    </>
  );
}

export default ViewQuestionDetail;
